import React from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import "./RestartModal.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  onYes: () => void;
}

const GameRestartModal = ({ open, onClose, onYes }: Props) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      classNames={{
        modal: "game-modal",
        closeIcon: "closer",
      }}
    >
      <div className="body">
        <p>Are you sure you want to abandon the current game and start a new one?</p>
      </div>

      <div className="button-bar">
        <button className="game-button" onClick={onYes}>
          Yes
        </button>
        <button className="game-button" onClick={onClose}>
          No
        </button>
      </div>
    </Modal>
  );
};

export default GameRestartModal;
